import { render, staticRenderFns } from "./SavedStates.vue?vue&type=template&id=21371ce4&scoped=true"
import script from "./SavedStates.vue?vue&type=script&lang=js"
export * from "./SavedStates.vue?vue&type=script&lang=js"
import style0 from "./SavedStates.vue?vue&type=style&index=0&id=21371ce4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21371ce4",
  null
  
)

export default component.exports